import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { isNavItemActive } from '../constants/navigationItems';
import { NavMoreMenu } from './NavMoreMenu';

const TIER_STYLES = {
  1: { minWidth: 76, minHeight: 54, icon: 20, font: 0.7 },
  2: { minWidth: 72, minHeight: 50, icon: 19, font: 0.68 },
  3: { minWidth: 68, minHeight: 48, icon: 18, font: 0.66 },
  4: { minWidth: 64, minHeight: 46, icon: 17, font: 0.64 },
  5: { minWidth: 60, minHeight: 44, icon: 16, font: 0.625 },
  6: { minWidth: 56, minHeight: 42, icon: 15, font: 0.6 },
  7: { minWidth: 52, minHeight: 40, icon: 14, font: 0.58 },
  8: { minWidth: 48, minHeight: 38, icon: 13, font: 0.55 },
};

export function HeaderQuickNav({
  slots = [],
  moreItems = [],
  onItemClick = () => {},
}) {
  const location = useLocation();

  if (!slots.length && !moreItems.length) return null;

  return (
    <nav
      className="header-quick-nav d-flex align-items-end flex-wrap gap-1"
      aria-label="Quick navigation"
    >
      {slots.map(({ item, sizeTier }) => {
        const Icon = item.icon;
        const active = isNavItemActive(item.path, location);
        const tier = TIER_STYLES[sizeTier] || TIER_STYLES[5];
        const shortName =
          item.shortLabel ||
          (item.label.length > 8 ? `${item.label.slice(0, 7)}…` : item.label);
        return (
          <Link
            key={item.id}
            to={item.path}
            className={`header-quick-nav__btn header-quick-nav__btn--tier-${sizeTier} ${
              active ? 'is-active' : ''
            }`}
            title={item.label}
            aria-label={item.label}
            style={{
              minWidth: `${tier.minWidth}px`,
              minHeight: `${tier.minHeight}px`,
            }}
            onClick={() => onItemClick(item)}
          >
            <Icon size={tier.icon} className="header-quick-nav__icon" aria-hidden />
            <span
              className="header-quick-nav__label"
              style={{ fontSize: `${tier.font}rem` }}
            >
              {shortName}
            </span>
          </Link>
        );
      })}
      <NavMoreMenu
        items={moreItems}
        location={location}
        onItemClick={onItemClick}
        variant="header"
        label="More"
      />
      <style>{`
        .header-quick-nav {
          flex: 1 1 auto;
          min-width: 0;
          justify-content: center;
          padding: 0 0.25rem;
        }
        .header-quick-nav__btn {
          display: inline-flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 0.15rem;
          max-width: 80px;
          padding: 0.35rem 0.4rem;
          border-radius: 0.5rem;
          border: 1px solid #e2e8f0;
          color: #475569;
          background: #fff;
          text-decoration: none;
          transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease,
            min-width 0.2s ease, min-height 0.2s ease;
        }
        .header-quick-nav__icon {
          flex-shrink: 0;
        }
        .header-quick-nav__label {
          font-weight: 600;
          line-height: 1.1;
          text-align: center;
          max-width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .header-quick-nav__btn:hover {
          background: #f8fafc;
          border-color: #cbd5e1;
          color: #0d6efd;
        }
        .header-quick-nav__btn.is-active {
          background: #0d6efd;
          border-color: #0d6efd;
          color: #fff;
        }
        .header-quick-nav__btn.is-active .header-quick-nav__label {
          color: inherit;
        }
        @media (max-width: 575.98px) {
          .header-quick-nav {
            order: 3;
            width: 100%;
            justify-content: flex-start;
            padding-top: 0.25rem;
            border-top: 1px solid #f1f5f9;
          }
        }
      `}</style>
    </nav>
  );
}
